import React from 'react';
import styled from 'styled-components';

const HelpDialogTop = (props) => {
    return(
        <React.Fragment>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <b>☆トレーニングガイドは<Movie href="https://englishcompany-mobile.jp/guide/" target="_blank" rel="noopener noreferrer">こちら</Movie>☆</b>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <h2>🔰はじめに</h2>

            <div>リーディング・リスニングスキルの向上、さらにはスピーキングスキルの土台作りに役立つ、ENGLISH COMPANYのオリジナルトレーニング<b>「速読リーディング」</b>に取り組みます。</div>
            <br />
            速読リーディングは、単語学習、チャンクリーディング、サイトトランスレーション、音読、シャドーイングなどいくつかのステップに分かれています。
            正しい方法で学習を進めることで大きな効果を発揮するので、トレーニングガイドを参考にしながら取り組んでいきましょう。
            各ステップでの学習の進め方は、右上の？マークでも確認できます。<br />
            <br />

            <h2>STEP1. 教材を選ぶ</h2>

            以下を参考に、ご自身の英語レベルに合った教材を1つ選択しましょう。<br />
            <br />
            初級：中学校卒業レベル<br />
            中級：TOEIC®500点以上<br />
            上級：TOEIC®800点以上<br />
        </React.Fragment>
    );
}

const Movie = styled.a`
`;

export { HelpDialogTop };
